import { useGlobalContext } from "../../../../../Context/Context";
import { useState } from "react";
import Button from "../../../../Custom/Button/Button";
import sortImg from "../../../../../picture/Sort.png";
import redniBrojeviImg from "../../../../../picture/redniBrojevi.png";
import sumaImg from "../../../../../picture/suma.png";

const styles = {
  cell: {
    padding: "5px",
    textAlign: "center"
  },
  smallCell: {
    width: "40px",
    textAlign: "center"
  },
  icon: {
    width: "30px",
    height: "30px"
  },
  cellPoimenicno: {
    padding: "5px",
    textAlign: "left",
    fontSize: "16px",
    paddingLeft: "150px"
  }
};

function RadnaMestaTabela({
  radnaMesta,
  checkedRows,
  setCheckedRows,
  isPoimenicno,
  isCheckedSort,
  setIsCheckedSort
}) {
  const [isCheckedRedniBrojevi, setIsCheckedRedniBrojevi] = useState(false);

  const [isCheckedAll, setIsCheckedAll] = useState(false);

  const { dictionary } = useGlobalContext();

  const handleCheckRedniBrojevi = () => {
    setIsCheckedRedniBrojevi((prev) => !prev);
  };
  const handleCheckSort = () => {
    setIsCheckedSort((prev) => !prev);
  };

  const handleCheckRow = (id) => {
    if (checkedRows.includes(id)) {
      setCheckedRows(checkedRows.filter((r) => r !== id));
    } else {
      setCheckedRows([...checkedRows, id]);
    }
  };
  const handleCheckAll = () => {
    if (isCheckedAll) {
      setCheckedRows([]);
    } else {
      setCheckedRows(radnaMesta.map((z) => z.id));
    }
    setIsCheckedAll((prev) => !prev);
  };

  return (
    <>
      <table style={{ width: "100%" }}>
        <tr>
          <th style={styles.smallCell}>
            <input
              type="checkbox"
              checked={isCheckedAll}
              onChange={handleCheckAll}
              style={{ width: "30px" }}
            />
          </th>
          <th style={{ width: "80px" }}>
            <div style={{ display: "flex" }}>
              <div onClick={handleCheckSort}>
                <Button active={isCheckedSort}>
                  <img
                    src={sortImg}
                    style={{ width: "40px", height: "30px" }}
                  />
                </Button>
              </div>
              <div onClick={handleCheckRedniBrojevi}>
                <Button active={isCheckedRedniBrojevi}>
                  <img
                    src={redniBrojeviImg}
                    style={{ width: "40px", height: "30px" }}
                  />
                </Button>
              </div>
            </div>
          </th>
          <th style={{ ...styles.cell, width: "40%" }}>
            {dictionary["nazivRadnogMesta"]}
          </th>
          <th style={styles.cell}>{dictionary["rizik"]}</th>
          <th style={styles.cell}>{dictionary["sprema"]}</th>
          <th style={styles.cell}>{dictionary["iskustvo"]}</th>
          <th style={styles.cell}>{dictionary["uslovi"]}</th>
          <th style={styles.cell}>
            <img src={sumaImg} style={{ width: "25px" }} />
          </th>
        </tr>
        {radnaMesta.map((radnoMesto, index) => (
          <>
            <tr key={radnoMesto.id}>
              <td style={styles.cell}>
                <input
                  type="checkbox"
                  checked={checkedRows.includes(radnoMesto.id)}
                  onChange={() => handleCheckRow(radnoMesto.id)}
                  style={{ width: "30px" }}
                />
              </td>
              <td
                style={{ padding: "5px" }}
              >{`${isCheckedRedniBrojevi ? radnoMesto.redniBroj : index + 1}.`}</td>
              <td style={styles.cell}>{radnoMesto.naziv}</td>
              <td style={styles.cell}>
                {radnoMesto.rizik === "NEDEFINISANO" ? "-" : radnoMesto.rizik}
              </td>
              <td style={styles.cell}>
                {radnoMesto.spreme.map((s) => s.naziv).join(", ")}
              </td>
              <td style={styles.cell}>{radnoMesto.iskustvo}</td>
              <td style={styles.cell}>
                {
                  (radnoMesto.posebniUslovi || radnoMesto.posebni_uslovi || [])
                    .length
                }
              </td>{" "}
              <td style={styles.cell}>{radnoMesto.suma}</td>
            </tr>
            {isPoimenicno &&
              (checkedRows.length === 0 ||
                checkedRows.includes(radnoMesto.id)) && (
                <tr>
                  <td colSpan={8} style={styles.cellPoimenicno}>
                    {(radnoMesto.imena || []).join(", ")}
                  </td>
                </tr>
              )}
          </>
        ))}
      </table>
    </>
  );
}

export default RadnaMestaTabela;
